import { Flex } from "@chakra-ui/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/session")({
  component: () => (
    <Flex
      height={["100vh", "100dvh"]}
      width={["100vw", "100dvw"]}
      flexDirection={"column"}
    >
      {/*
        This is the layout route for `/session` and its children (e.g.
        `/session/remote-rendering-node-backchannel`). It must render an
        <Outlet /> so nested routes actually mount — the page for `/session`
        itself lives in `session/index.tsx`. Rendering a concrete page here
        instead would swallow every child route, silently showing the session
        page for any `/session/*` URL.
      */}
      <Outlet />
    </Flex>
  ),
});
